import React from "react";
import SalaryConfig from "./SalaryConfig";

const SalaryConfigSection = ({ userDetails, selectedClient }) => {
  return (
    <div className='grid-item-container'>
      <SalaryConfig userDetails={userDetails} selectedClient={selectedClient} />
    </div>
  );
};

export default SalaryConfigSection;
